module.exports = __webpack_public_path__ + "img/form-banner.75f3f7f5.svg";